// Button Appearence
export enum EKwikUIButtonAppearance {
  PRIMARY = "primary",
  ACCENT = "accent",
  SECONDARY = "secondary",
  SECONDARY_DESTRUCTIVE = "secondary-destructive",
  OUTLINE = "outline",
  MONO = "mono",
  FLAT = "flat",
  WHITEBLOCK = "whiteblock",
  WHITEBLOCK_ACTIVE = "whiteblock-active",
  ICON = "icon"
}

export const VKwikUIButtonAppearance = [
  EKwikUIButtonAppearance.PRIMARY,
  EKwikUIButtonAppearance.ACCENT,
  EKwikUIButtonAppearance.SECONDARY,
  EKwikUIButtonAppearance.SECONDARY_DESTRUCTIVE,
  EKwikUIButtonAppearance.OUTLINE,
  EKwikUIButtonAppearance.MONO,
  EKwikUIButtonAppearance.FLAT,
  EKwikUIButtonAppearance.WHITEBLOCK,
  EKwikUIButtonAppearance.WHITEBLOCK_ACTIVE,
  EKwikUIButtonAppearance.ICON
] as const;

export type TKwikUIButtonAppearance = (typeof VKwikUIButtonAppearance)[number];

// Button Type
export enum EKwikUIButtonType {
  BUTTON = "button",
  SUBMIT = "submit",
  RESET = "reset"
}
export const VKwikUIButtonType = [
  EKwikUIButtonType.BUTTON,
  EKwikUIButtonType.SUBMIT,
  EKwikUIButtonType.RESET
] as const;

export type TKwikUIButtonType = (typeof VKwikUIButtonType)[number];

// Button Shape
export enum EKwikUIButtonShape {
  SQUARE = "square",
  ROUNDED = "rounded"
}
export const VKwikUIButtonShape = [
  null,
  EKwikUIButtonShape.SQUARE,
  EKwikUIButtonShape.ROUNDED
] as const;

export type TKwikUIButtonShape = (typeof VKwikUIButtonShape)[number];

// Button Size
export enum EKwikUIButtonSize {
  XS = "xs",
  S = "s",
  M = "m",
  L = "l",
  XL = "xl"
}
export const VKwikUIButtonSize = [
  EKwikUIButtonSize.XS,
  EKwikUIButtonSize.S,
  EKwikUIButtonSize.M,
  EKwikUIButtonSize.L,
  EKwikUIButtonSize.XL
] as const;

export type TKwikUIButtonSize = (typeof VKwikUIButtonSize)[number];
